export const humanReadableServerErrors = (e) => {
	console.log('humanReadableServerErrors TEST:', e);

	const returnError = errors[e];

	if (!returnError) {
		return 'An Error has occurred';
	} else {
		return returnError;
	}
};

// @TODO: Run this through the translator.
const errors = {
	'Temporary password has expired and must be reset by an administrator.':
		'Temporary password has expired',
	'Incorrect username or password.': 'Incorrect username or password.'
};
